import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import VisibilitySensor from 'react-visibility-sensor';

import VideoTag from './VideoTag';

const Video = styled(VideoTag)`
  pointer-events: none;

  video {
    display: block;
    width: 100%;
  }
`;

const assetProp = PropTypes.shape({
  path: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['mp4', 'webm', 'ogg']).isRequired,
});

class AutoVideo extends React.Component {
  static propTypes = {
    assets: PropTypes.arrayOf(assetProp),
    onLoad: PropTypes.func,
    autoPlay: PropTypes.bool,
  };

  static defaultProps = {
    autoPlay: true,
  };

  state = {
    isVisible: false,
  };

  componentDidUpdate(prevProps, prevState) {
    const needUpdate =
      prevState.isVisible !== this.state.isVisible ||
      (prevProps.autoPlay !== this.props.autoPlay && this.props.autoPlay);

    if (needUpdate) {
      this.update();
    }
  }

  componentInViewport = isVisible => {
    this.setState({ isVisible });
  };

  update() {
    if (!this.videoNode) {
      return;
    }

    if (this.state.isVisible && this.props.autoPlay) {
      this.play();
    } else {
      this.pause();
    }
  }

  play() {
    if (this.videoNode.paused) {
      this.videoNode.play().catch(e => console.warn(e));
    }
  }

  pause() {
    if (!this.videoNode.paused) {
      this.videoNode.pause();
    }
  }

  render() {
    const { assets, onLoad, ...rest } = this.props;
    return (
      <VisibilitySensor onChange={this.componentInViewport} partialVisibility>
        <Video {...rest} assets={assets} videoRef={node => (this.videoNode = node)} onLoadedData={onLoad} />
      </VisibilitySensor>
    );
  }
}

export default AutoVideo;



// WEBPACK FOOTER //
// ./src/components/AutoVideo.js